module.exports = __webpack_public_path__ + "static/media/trees.c5162050.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/trees.png
// module id = 372
// module chunks = 0